// HS Form Context
import * as React from 'react';
import { OpenHouse } from '../classes/openHouse/OpenHouse';

import { Sanitized } from '../@types/sanitized';
import { NewOpenHouseData } from '../pages/partials/changeAdType';
import { GenericContextHandlers } from './GenericContext';
import { BillingContext } from './BillingContext';

export type ContextHandlers = GenericContextHandlers &
    BillingContext & {
        contextType: 'listing';
        cartItem: Sanitized.CartItem;
        updateCartItemSubType: (
            name: string,
            value: any,
            setCreativeLoading: (val: boolean) => void
        ) => Promise<any>;
        handleChange: (
            nameValuePairs: Array<Sanitized.CartItemNameValuePair>,
            updateCartOnServer?: boolean | null,
            chosenSpendRatio?: Sanitized.spendRatioObject | null
        ) => Promise<any>;
        promotableOptions: Array<Sanitized.PromotableOption>;
        openHouses: Array<OpenHouse>;
        getOpenHouses: () => Promise<any>;
        getCartItemAndCreative: () => Promise<any>;
        updateFullCart: (newCartItem: Sanitized.CartItem) => void;
        setViewUploadOwnAd: (isOwnAdShowing: boolean) => void;
        viewUploadOwnAd: boolean;
        setCroppedImage: (croppedImage: string) => void;
        createNewOpenHouse: (openHouseData: NewOpenHouseData) => Promise<any>;
        agentExperiment: 'control' | 'darker' | string;
        increaseExposure: boolean;
        isDraft: boolean;
        customerBrandingColors?: Sanitized.customerBrandingColorsObject;
        changeSpendRatioToAdTypeDefault: (adType: string) => void;
        requiresPrepayment: boolean;
        frontEndStripeDataFields: Sanitized.frontEndStripeDataFieldsObject;
        confirmationPageData: Sanitized.confirmationPageDataObject;
        setConfirmationPageData: (data: Sanitized.confirmationPageDataObject) => void;
        message: string;
        setMessage: (message: string) => void;
        creditCardValueChanged: boolean;
        setCreditCardValueChanged: (value: boolean) => void;
        setDiscountPercentage: (discount: number) => void;
        subscribeToNewListings: boolean;
        subscribeToOpenHouses: boolean;
        subscribeToPriceReductions: boolean;
        subscribeToJustSold: boolean;
        item_size: number;
        agentID: string;
        current_discount: number;
        customerGetsSSDiscount: boolean;
        duration_in_seconds: number;
        isSubscribedToAutomateSave: boolean;
        supportsPriceReduced: boolean;
        supportsJustSolds: boolean;
        subscribeAndSaveSettingsData?: Sanitized.subscribeAndSaveDataObject;
        hasNextdoorSupport: boolean;
        automateSaveCheckboxChecked: boolean;
        automateSaveRadioSelected: boolean;
        disableUI: boolean;
        setDisableUI: (disableUI: boolean) => void;
        isOutsideUSA: () => boolean;
        showLoginModal: boolean;
    };

const HsContext = React.createContext<Partial<ContextHandlers>>({});

export const useHSContext = (): Partial<ContextHandlers> => React.useContext(HsContext);

export default HsContext;
